import { type RouteRecordRaw } from 'vue-router';

import { FUNNEL_STEPS } from '@/modules/spam-blocker/hooks/funnelSteps';

export enum MODULE_ROUTE {
  funnel = 'SpamBlockerFunnel',
}

function preloadAllSteps() {
  setTimeout(() => {
    FUNNEL_STEPS.forEach((step) => step.component());
  }, 1000);
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/:lang?/pricing/spam-blocker/',
    component: () => import('@/modules/spam-blocker/layout/LayoutDefault.vue'),
    meta: {
      i18nAlias: 'pricing',
    },
    children: [
      {
        path: '',
        name: MODULE_ROUTE.funnel,
        component: () =>
          import('@/modules/spam-blocker/layout/FunnelOrchestrator.vue'),
        meta: {
          abtestGroup: 1,
        },
        beforeEnter() {
          preloadAllSteps();
        },
      },
      {
        path: ':stepId/',
        name: `${MODULE_ROUTE.funnel}Step`,
        component: () =>
          import('@/modules/spam-blocker/layout/FunnelOrchestrator.vue'),
        meta: {
          i18nAlias: 'pricing',
        },
      },
    ],
  },
];
